/**
 * on mouse drag scroll element
 */
export default class dragToScroll {
  constructor (element) {
    this.element = element
    this.holding = false
    if (this.element) {
      this.pos = { left: 0, x: 0 }

      document.addEventListener('mousemove', (e) => {
        if (!this.holding) return
        const dx = e.clientX - this.pos.x
        this.element.scrollLeft = this.pos.left - dx
      })

      document.addEventListener('mouseup', () => {
        this.holding = false
      })
      document.addEventListener('mouseleave', () => {
        this.holding = false
      })

      // Attach event the handler
      this.element.addEventListener('mousedown', (e) => {
        this.holding = true
        this.pos = {
          left: this.element.scrollLeft,
          x: e.clientX
        }
      })
    }
  }
}
